<template>
	<div>
		<p
			v-if="
				$tera.project.unitOfAnalysisType === 'Individual' ||
					$tera.project.unitOfAnalysisType === 'Individual and other'
			"
		>
			{{
				selectRandom([
					"We used "
						.concat(
							$tera.project.unitOfAnalysisType
								? $tera.project.unitOfAnalysisType.toLowerCase()
								: "BLANK"
						)
						.concat(
							$tera.project.unitOfAnalysisType
								? $tera.project.unitOfAnalysisType.toLowerCase()
								: "BLANK"
						)
						.concat(" participants as the unit of analysis."),
					"The unit of analysis was "
						.concat(
							$tera.project.unitOfAnalysisType
								? $tera.project.unitOfAnalysisType.toLowerCase()
								: "BLANK"
						)
						.concat(
							$tera.project.unitOfAnalysisType
								? $tera.project.unitOfAnalysisType.toLowerCase()
								: "BLANK"
						)
						.concat(" patients.")
				])
			}}
		</p>
		<p v-if="$tera.project.unitOfAnalysisType === 'Individual and other'"></p>
		<p v-if="$tera.project.unitOfAnalysisType === 'Individual and other'">
			{{
				"Where data on the number of individuals with primary and secondary outcomes of interest was not available, we extracted the information as it presented(e.g. "
					.concat($tera.project.example ? $tera.project.example : "BLANK")
					.concat(").")
			}}
			{{
				"Where the unit of randomisation was not at individual level we "
					.concat($tera.project.example2 ? $tera.project.example2 : "BLANK")
					.concat(".")
			}}
			{{
				"For studies that presented outcomes in other units, this data was extracted as presented."
			}}
		</p>
		<p v-if="$tera.project.unitOfAnalysisType === 'Other'"></p>
		<p v-if="$tera.project.unitOfAnalysisType === 'Other'">
			The unit of analysis was
			{{
				$tera.project.otherType ? $tera.project.otherType.toLowerCase() : "BLANK"
			}}.
		</p>
	</div>
</template>
<script>
import OutputMixin from "@/mixins/OutputMixin.js";
export default {
	name: "OutputUnitOfAnalysis",
	mixins: [OutputMixin]
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
